/**
 * Browser detection utilities
 * Minimal, focused on Firefox detection for share functionality
 */

/**
 * Detect if current browser is Firefox
 * @returns {boolean} True if browser is Firefox
 */
export const isFirefox = () => {
  if (typeof window !== 'undefined' && window.Capacitor?.isNativePlatform?.()) return false;
  if (typeof navigator === 'undefined' || !navigator.userAgent) return false;
  const ua = navigator.userAgent.toLowerCase();
  return ua.includes('firefox') || ua.includes('fxios');
};

/**
 * Detect if current browser is Firefox on mobile
 * @returns {boolean} True if browser is Firefox on mobile device
 */
export const isMobileFirefox = () => {
  return isFirefox() && /Mobi|Android/i.test(navigator.userAgent);
};
